function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "check_circle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 0c282.77 0 512 229.23 512 512s-229.23 512-512 512S0 794.77 0 512 229.23 0 512 0",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M511.97 85.3C276.45 85.3 85.3 276.45 85.3 511.97s191.15 426.67 426.67 426.67 426.67-191.15 426.67-426.67S747.48 85.3 511.97 85.3ZM396.34 695 243.17 541.83c-16.64-16.64-16.64-43.52 0-60.16 16.64-16.64 43.52-16.64 60.16 0l123.31 122.88L720.19 311c16.64-16.64 43.52-16.64 60.16 0 16.64 16.64 16.64 43.52 0 60.16L456.51 695c-16.21 16.64-43.52 16.64-60.16 0Z",
    style: {
      clipPath: "url(#check_circle_svg__a)"
    }
  }));
};
export default SvgCheckCircle;